/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LogoutInputs */

const id_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const ms_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

const da_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ud`)
};

const de_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const en_us2_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const es_es2_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const es_mx2_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const fil_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const fr_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const it_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const hu_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kijelentkezés`)
};

const nl_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitloggen`)
};

const no_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg ut`)
};

const pl_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

const pt_br2_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const pt_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const ro_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deconectare`)
};

const fi_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu ulos`)
};

const sv_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga ut`)
};

const vi_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng xuất`)
};

const tr_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış Yap`)
};

const cs_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhlásit se`)
};

const bg_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изход`)
};

const ru_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const uk_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти`)
};

const ar_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الخروج`)
};

const hi_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग आउट`)
};

const th_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากระบบ`)
};

const ja_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const zh_cn2_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出登录`)
};

const zh_hant1_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const ko_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Nav_LogoutInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_logout = /** @type {((inputs?: Nav_LogoutInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LogoutInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_logout(inputs)
	if (locale === "ms") return ms_nav_logout(inputs)
	if (locale === "da") return da_nav_logout(inputs)
	if (locale === "de") return de_nav_logout(inputs)
	if (locale === "en-US") return en_us2_nav_logout(inputs)
	if (locale === "es-ES") return es_es2_nav_logout(inputs)
	if (locale === "es-MX") return es_mx2_nav_logout(inputs)
	if (locale === "fil") return fil_nav_logout(inputs)
	if (locale === "fr") return fr_nav_logout(inputs)
	if (locale === "it") return it_nav_logout(inputs)
	if (locale === "hu") return hu_nav_logout(inputs)
	if (locale === "nl") return nl_nav_logout(inputs)
	if (locale === "no") return no_nav_logout(inputs)
	if (locale === "pl") return pl_nav_logout(inputs)
	if (locale === "pt-BR") return pt_br2_nav_logout(inputs)
	if (locale === "pt") return pt_nav_logout(inputs)
	if (locale === "ro") return ro_nav_logout(inputs)
	if (locale === "fi") return fi_nav_logout(inputs)
	if (locale === "sv") return sv_nav_logout(inputs)
	if (locale === "vi") return vi_nav_logout(inputs)
	if (locale === "tr") return tr_nav_logout(inputs)
	if (locale === "cs") return cs_nav_logout(inputs)
	if (locale === "bg") return bg_nav_logout(inputs)
	if (locale === "ru") return ru_nav_logout(inputs)
	if (locale === "uk") return uk_nav_logout(inputs)
	if (locale === "ar") return ar_nav_logout(inputs)
	if (locale === "hi") return hi_nav_logout(inputs)
	if (locale === "th") return th_nav_logout(inputs)
	if (locale === "ja") return ja_nav_logout(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_logout(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_logout(inputs)
	return ko_nav_logout(inputs)
});
export { nav_logout as "nav.logout" }